// Core sends a role's bundle verbatim in /auth/me and expands wildcards at
// evaluation time: a webmaster arrives with exactly ['*'] and an owner with
// ['public:*']. A plain Set lookup would deny the most powerful accounts.
// Mirrors matches() in mastermind_core core/authz/permissions.js; keep both in sync.
export function grantMatches(granted, required) {
    if (typeof granted !== 'string' || typeof required !== 'string') return false;
    if (granted === '*' || granted === required) return true;
    // 'tasks:*' matches 'tasks:read': the slice keeps the colon.
    if (granted.endsWith(':*')) return required.startsWith(granted.slice(0, -1));
    return false;
}

export function holdsPermission(granted, required) {
    if (granted.has(required)) return true;
    for (const grant of granted) {
        if (grantMatches(grant, required)) return true;
    }
    return false;
}

// /auth/me returns the UserPackage flat; /auth/login wraps it in { user }.
export function readAccount(payload) {
    return payload?.user ?? payload ?? null;
}
